var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-table',{attrs:{"data":_vm.table.data,"columns":_vm.table.columns,"thead-classes":"text-primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }